import { render } from "./ExampleForm.vue?vue&type=template&id=09b61bbc"
import script from "./ExampleForm.vue?vue&type=script&lang=js"
export * from "./ExampleForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__